export var QB_SLOTS = {
    media_element: {
        slotA: ['slot a', 'media_element_a'],
        // slotB: ['slot b', 'media_element_b']
    }
};
export var BLOCK_OPERATOR_OPTIONS = {
    OR: 'ANY',
    AND: 'ALL',
};
export var MATCH_OPERATOR_OPTIONS = {
    contains: 'contains',
    equals: 'equals',
    start_with: 'starts with',
    end_with: 'ends with',
};
export var KEYWORD_OPTIONS = {
    asset_Name: 'asset name',
    keyword: 'keyword',
    fileName: 'filename',
};
export var QB_MEDIA_ELEMENT_OPTIONS = {
    download_original: 'download original',
    download_proxy: 'download preview',
    add_to_folder: 'add to folder',
};
export var SORT_BY_KEYS = {
    importDate: "Import Date",
    asset_Name: "Asset Name",
    category: "Category",
    fileName: "Filename",
    first_Show: "First Show"
};
// ============================================================================
// Default Values
// ============================================================================
export var defaultSystemConfig = {
    id: 1,
    admin_eval: false,
    download_as_client: false,
};
export var defaultDownload = [];
export var defaultUser = {
    profile: {},
    permissions: [],
    activeFolder: null,
};
export var defaultScope = {
    projects: [],
    types: [],
    season: [],
    seasonProjectId: null,
    episode: [],
    episodeScopeKey: '',
    firstShow: false
};
export var nulledScopeSelection = {
    projects: null,
    types: null,
    seasons: null,
    episodes: null,
    firstShow: false
};
export var defaultCollection = {
    static: [],
    dynamic: [],
};
export var defaultFilters = {
    project: [],
    type: [],
    stage: [],
    category: []
};
export var defaultActiveSelection = {
    saved_search: null,
    pendingDynamicHydration: null,
    scpp: null,
    coll: null,
    srch: null,
    fltr: null
};
export var defaultMedia = {
    items: [],
    total: 0
};
export var defaultMediaSelection = {
    selection: null,
    modalActive: false,
    modalType: null,
    selectedIds: [],
    selectedItems: [],
    removingIds: [],
    urlSelectionState: {
        scpp: null,
        srch: null,
        fltr: null,
    },
};
export var defaultPageParameters = {
    pg: 0,
    pgSz: 25,
    sortBy: 'asset_Name',
    sortDir: 'asc'
};
export var defaultError = {
    fatal: null,
    local: {},
};
